import { FC } from 'app/FunctionalComponent'
import React from 'react'
import classes from './Tabs.module.scss'

export const Tabs: FC = (props: { children?: React.ReactNode }) => {
	return <div className={`${classes.tabs}`}>{props.children}</div>
}
